import {
  type ResearchScope,
  ResearchScopeSchema,
  type ResearchSort,
  ResearchSortSchema,
  type ResearchStatusFilter,
  ResearchStatusFilterSchema,
  type SortDirection,
  SortDirectionSchema,
} from "@pokifolio/contracts";

/** The Research page's filters, kept in the address so Back returns to the same view. Defaults are left out. */
export interface ResearchListSearch {
  readonly scope?: Exclude<ResearchScope, "all">;
  readonly status?: Exclude<ResearchStatusFilter, "open">;
  /** Words to find (card, set, listing title or website). */
  readonly q?: string;
  readonly sort?: Exclude<ResearchSort, "updated">;
  readonly dir?: Exclude<SortDirection, "desc">;
  readonly page?: number;
}

/** Reads the filters from the address; anything unknown falls back to the default (everyone's open research). */
export function parseResearchListSearch(search: Record<string, unknown>): ResearchListSearch {
  const scope = ResearchScopeSchema.safeParse(search.scope);
  const status = ResearchStatusFilterSchema.safeParse(search.status);
  const sort = ResearchSortSchema.safeParse(search.sort);
  const dir = SortDirectionSchema.safeParse(search.dir);
  const q = typeof search.q === "string" ? search.q.trim().slice(0, 100) : "";
  const page = Number(search.page);
  return {
    ...(scope.success && scope.data !== "all" ? { scope: scope.data } : {}),
    ...(status.success && status.data !== "open" ? { status: status.data } : {}),
    ...(q !== "" ? { q } : {}),
    ...(sort.success && sort.data !== "updated" ? { sort: sort.data } : {}),
    ...(dir.success && dir.data !== "desc" ? { dir: dir.data } : {}),
    ...(Number.isInteger(page) && page > 1 && page <= 10_000 ? { page } : {}),
  };
}
